import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { DecimalPipe } from '@angular/common';
import { AbsoluteNumberPipe } from '@flexus/pipes';

@Directive({
	selector: '[allowOnlyNaturalNumbers]'
})
export class AllowOnlyNaturalNumbersDirective {
	constructor(private _elementRef: ElementRef, private _decimalPipe: DecimalPipe, private _absoluteNumberPipe: AbsoluteNumberPipe, private _control: NgControl) {}

	@HostListener('blur', ['$event.target'])
	public onBlur(targetElement) {
		if (this._elementRef.nativeElement.value) {
			this._control.control?.setValue(this._decimalPipe.transform(Math.abs(this._elementRef.nativeElement.value), '1.0-0'));
		}
	}
}
